import { clampApiPageLimit } from './list-query.utils';

/**
 * Largura da janela (px) → itens por página.
 * Ordem: da menor faixa para a maior. Última linha cobre o restante.
 */
export const ITEMS_PER_PAGE_BY_WIDTH: ReadonlyArray<{ maxWidth: number; items: number }> = [
  { maxWidth: 500, items: 4 },
  { maxWidth: 600, items: 5 },
  { maxWidth: 700, items: 6 },
  { maxWidth: 800, items: 7 },
  { maxWidth: 900, items: 8 },
  { maxWidth: 1024, items: 9 },
  { maxWidth: 1280, items: 10 },
  { maxWidth: 1536, items: 12 },
  { maxWidth: Infinity, items: 15 },
];

const DEFAULT_ITEMS = 10;

export function getItemsPerPage(viewportWidth: number): number {
  if (!Number.isFinite(viewportWidth) || viewportWidth <= 0) {
    return clampApiPageLimit(DEFAULT_ITEMS);
  }

  for (const row of ITEMS_PER_PAGE_BY_WIDTH) {
    if (viewportWidth <= row.maxWidth) {
      return clampApiPageLimit(row.items);
    }
  }

  return clampApiPageLimit(DEFAULT_ITEMS);
}
